/* eslint-disable max-lines */
/* eslint-disable max-statements */
import styled from 'styled-components'
import React, { Fragment, useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Card from '@taglivros/oef_componentes/build/components/card'
import Toast from '@taglivros/oef_componentes/build/components/toast'
import { useGlobal } from '../../../../contexts/GlobalContext'
import { useCartaoCredito } from '../../../../contexts/CartaoCreditoContext'
import {
  TITULO_PAGINA,
  TEXTO_MODAL_EXCLUSAO_CARTAO,
  TITULO_ADICIONAR_CARTAO,
  MODAL_CONFIRMAR,
  MODAL_CANCELAR,
  HELPER_TEXT,
} from './constantsTrocarFormaPagamento'
import CardAdicionar from '../../../../components/CardAdicionar'
import CardCartao from '../../../../containers/Modalidade/components/CardCartao/CardCartao'
import ConteudoWrapper from '../../../../components/ConteudoWrapper/ConteudoWrapper'
import ModalConfirmacao from '../../../../components/ModalConfirmacao/ModalConfirmacao'
import BreadcrumbGlobal from '../../../../components/BreadcrumbGlobal/BreadcrumbGlobal'
import CartaoCreditoForm from '../../../../components/CartaoCreditoForm/CartaoCreditoForm'
import ModalConfirmaCartaoVigente from '../../../../containers/Modalidade/components/ModalConfirmaCartaoVigente/ModalConfirmaCartaoVigente'
import ModalAvisoProcessamento from '../../../../containers/Modalidade/components/ModalAvisoProcessamento/ModalAvisoProcessamento'
import { isEmptyObject } from '../../../../utils/helpers/helpers'
import InlineLoader from '../../../../components/InlineLoader/InlineLoader'
import { getAssinaturaDoAssociadoPorModalidade } from '../../../../utils/helpers/helpersAssinatura'
import { METODO_PAGAMENTO_CARTAO } from '../../../../constants'
import WrapperComponent from '../../../../containers/Opcionais/WrapperComponent'

const TituloPagina = styled.h1`
  margin: 0 auto 10px;

  @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
    margin: 0 auto;
  }
`

const WrapperToast = styled.div`
  .toast {
    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
     margin-top: 20px;
    }
  }
`

const WrapperOpcional = styled.div`
  max-width: 416px;
  margin-top: 20px;
  background: white;
  border-radius: 17px;
  .div-description {
    padding: 10px 10px 15px 17px;
  }
`

const TrocarFormaPagamento = () => {
  const {
    cartaoAdicionado,
    cartaoExcluido,
    cartaoSelecionado,
    cartaoVigente,
    cartoesCadastrados,
    deleteCartao,
    getCartoes,
    getInfosPagamento,
    infosPagamento,
    loading,
    loadingRemoveCartao,
    postCartao,
    postCartaoVigente,
    setCartaoAdicionado,
    setCartaoExcluido,
    setCartaoSelecionado,
    setErrosCartao
  } = useCartaoCredito()

  const [ toast, setToast ] = useState( {} )
  const [ idAssinatura, setIdAssinatura ] = useState()
  const [ cartaoExclusao, setCartaoExclusao ] = useState()
  const [ modalExclusao, setModalExclusao ] = useState( false )
  const [ openFormulario, setOpenFormulario ] = useState( false )
  const [ modalConfirmacao, setModalConfirmacao ] = useState( false )
  const [ modalProcessamento, setModalProcessamento ] = useState( false )
  const [ showHelper, setShowHelper ] = useState( false )
  const [ statusAssinatura, setStatusAssinatura ] = useState( '' )
  const [ loadingTrocaCartao, setLoadingTrocaCartao ] = useState( '' )
  const [ shouldReloadForCardChange, setShouldReloadForCardChange ] = useState( false )
  const { dadosGlobaisAssociado, modalidadeURL } = useGlobal()

  useEffect( () => {
    if ( idAssinatura ) {
      getCartoes( idAssinatura )
    }
    setCartaoSelecionado( {} )
  }, [ idAssinatura ] )

  useEffect( () => {
    if ( cartoesCadastrados?.length > 0 ) {
      const cardsWithNoiDGatway = cartoesCadastrados.filter( cartao => !cartao.soft_delete && cartao.idGateway === '' )

      if ( cardsWithNoiDGatway.length > 0 ) {
        setShowHelper( true )
      } else {
        setShowHelper( false )
      }
    }
  }, [ cartoesCadastrados ] )

  useEffect(
    () => {
      if ( dadosGlobaisAssociado ) {
        const assinaturaObtida = getAssinaturaDoAssociadoPorModalidade(
          dadosGlobaisAssociado.assinaturas,
          modalidadeURL
        )
        if ( assinaturaObtida ) {
          setStatusAssinatura( assinaturaObtida.status )
          setIdAssinatura( assinaturaObtida.id )
        }
      }
    },
    [ dadosGlobaisAssociado ]
  )

  useEffect( () => {
    if ( idAssinatura ) {
      getInfosPagamento( idAssinatura, dadosGlobaisAssociado.assinaturas )
    }
  }, [ idAssinatura ] )

  useEffect( () => {
    if ( cartaoSelecionado && Object.keys( cartaoSelecionado ).length ) {
      setModalConfirmacao( true )
    }
  }, [ cartaoSelecionado ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setCartaoAdicionado( false ),
      'message': 'Cartão adicionado com sucesso!',
      'show': cartaoAdicionado
    } )

    setOpenFormulario( false )
    if ( shouldReloadForCardChange ) {
      window.location.reload( false )
    }
  }, [ cartaoAdicionado ] )

  useEffect( () => {
    setToast( {
      'funcao': () => setCartaoExcluido( false ),
      'message': 'Cartão excluído com sucesso!',
      'show': cartaoExcluido
    } )
  }, [ cartaoExcluido ] )

  const isVigente = item => {
    if ( infosPagamento.metodoPagamento !== METODO_PAGAMENTO_CARTAO.inicial ) {
      return false
    }
    if ( cartaoVigente ) {
      return item.id === cartaoVigente.id
    } else {
      return item.vigencia.assinaturas.includes( idAssinatura )
    }
  }

  const usarComoVigente = cartao => {
    setCartaoSelecionado( cartao )
  }

  const confirmaExclusao = cartaoId => {
    setCartaoExclusao( cartaoId )
    setModalExclusao( true )
  }

  const excluirCartao = cartaoId => {
    deleteCartao( cartaoId, idAssinatura )
    setModalExclusao( false )
  }

  const onCancelarVigente = () => {
    setModalConfirmacao( false )
    setCartaoSelecionado( {} )
    getCartoes( idAssinatura )
  }

  const onConfirmarVigente = cartao => {
    setLoadingTrocaCartao( cartao.id )
    postCartaoVigente( cartao, idAssinatura )
    getInfosPagamento( idAssinatura, dadosGlobaisAssociado.assinaturas )
    setShouldReloadForCardChange( true )
    setModalConfirmacao( false )
    setOpenFormulario( false )
  }

  const hideModalProcessamento = () => {
    setModalProcessamento( false )
  }

  const cadastraCartao = cartao => {
    postCartao( cartao, idAssinatura, hideModalProcessamento )
    getInfosPagamento( idAssinatura, dadosGlobaisAssociado.assinaturas )
    setModalProcessamento( !modalProcessamento )
  }

  const cancelarCadastroCartao = () => {
    setOpenFormulario( false )
    setErrosCartao( {} )
  }

  const modalRender = () => {
    return (
      <>
        {modalConfirmacao ? !isEmptyObject( cartaoSelecionado ) && (
          <ModalConfirmaCartaoVigente
            cartaoAdicionado={ cartaoSelecionado }
            cartaoVigente={ cartaoVigente }
            onCancelar={ () => onCancelarVigente() }
            onConfirmar={ () => onConfirmarVigente( cartaoSelecionado ) }
            open={ modalConfirmacao }
          />
        ) : null}

        {modalProcessamento ? (
          <ModalAvisoProcessamento
            onCancelar={ () => setModalProcessamento( !modalProcessamento ) }
            open={ modalProcessamento }
          />
        ) : null}

        {modalExclusao ? (
          <ModalConfirmacao
            acaoPrimariaTitulo={ MODAL_CONFIRMAR }
            acaoSecundariaTitulo={ MODAL_CANCELAR }
            onClickAcaoPrimaria={ () => excluirCartao( cartaoExclusao ) }
            onClickAcaoSecundaria={ () => setModalExclusao( false ) }
            titulo={ TEXTO_MODAL_EXCLUSAO_CARTAO }
          />
        ) : null}
      </>
    )
  }

  return (
    <Fragment>
      { modalRender() }

      <BreadcrumbGlobal
        exactPath="trocar-forma-pagamento"
        nomeAlternativo="Trocar forma de pagamento"
        padding="20px 0"
      />

      <TituloPagina>{TITULO_PAGINA}</TituloPagina>

      <WrapperToast>
        <Toast
          close={ toast.funcao ? toast.funcao : () => {} }
          fullWidth={ true }
          message={ toast.message ? toast.message : '' }
          show={ toast.show }
          type="success"
        />
      </WrapperToast>

      {showHelper ? (
        <WrapperOpcional>
          <WrapperComponent opcional={ HELPER_TEXT } />
        </WrapperOpcional>
      ) : null}

      <ConteudoWrapper>

        {!openFormulario ? (
          <CardAdicionar
            margin={ StyleGuide.isMobile() ? '20px auto' : '0 0 30px' }
            onClick={ () => setOpenFormulario( true ) }
            titulo={ TITULO_ADICIONAR_CARTAO }
          />
        ) : (
          <Card
            className="card"
            padding="25px"
          >
            <CartaoCreditoForm
              loading={ loading }
              onCancelar={ () => cancelarCadastroCartao() }
              onConfirmar={ cartaoRetornado => cadastraCartao( cartaoRetornado ) }
            />
          </Card>
        )}

        {cartoesCadastrados ? (
          <>
            {cartoesCadastrados.map( item => (
              <CardCartao
                ativo={ isVigente( item ) }
                botaoExcluir={ !isVigente( item ) || statusAssinatura === 'Cancelado' }
                cartao={ item }
                isVigente={ isVigente( item ) }
                key={ item.id }
                loading={ loadingRemoveCartao === item.id || loadingTrocaCartao === item.id }
                onExcluir={ () => confirmaExclusao( item.id ) }
                showExcluir={ !loading && !loadingRemoveCartao }
                usarComoVigente={ () => usarComoVigente( item ) }
              />
            ) )}
          </>
        ) : (
          <InlineLoader isCenter />
        )}
      </ConteudoWrapper>
    </Fragment>
  )
}

export default TrocarFormaPagamento
